import { ApolloLink, ApolloClient, from, HttpLink } from '@apollo/client';
import { TREASURY_HTTP_URL } from './config';
import { createTreasuryCache } from './treasury-apollo-cache';

const httpLink = new HttpLink({
  uri: TREASURY_HTTP_URL,
  credentials: 'include',
});

const link = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      'x-moba-proxy-gql-ops-name': operation.operationName,
    },
  }));

  return forward(operation);
});

export const treasuryApolloClient = new ApolloClient({
  cache: createTreasuryCache(),
  link: from([link, httpLink]),
  defaultOptions: {
    query: {
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
});

// @ts-ignore
window.treasuryApolloClient = treasuryApolloClient;
